export const EMAIL_PATTERN = /^[\w+\-.]+@([\w-]+\.)+[\w-]{2,4}$/;
